import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Переключатель темы 85×46 (макет): трек + бегунок с градиентом, солнце / луна.
 */
const ThemeSwitch = ({ compact = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  // Ықшам нұсқа — h-14 тақырып жолағына (админ layout) арналған 36×36 батырма
  if (compact) {
    const Icon = isLight ? MoonIcon : SunIcon;
    return (
      <button
        type="button"
        onClick={toggleTheme}
        title={isLight ? 'Қараңғы темаға ауысу' : 'Жарық темаға ауысу'}
        aria-label={isLight ? 'Қараңғы темаға ауысу' : 'Жарық темаға ауысу'}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border-primary bg-bg-primary text-text-secondary transition-colors hover:bg-bg-tertiary hover:text-text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F45E5]"
      >
        <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
      </button>
    );
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isLight}
      onClick={toggleTheme}
      title={isLight ? 'Қараңғы темаға ауысу' : 'Жарық темаға ауысу'}
      className="relative h-[46px] w-[85px] shrink-0 rounded-[30px] border border-[#CED4DA] bg-[#F1F5F9] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F45E5] focus-visible:ring-offset-2 dark:border-[#333333] dark:bg-[#1C2126] dark:focus-visible:ring-offset-[#11161C]"
    >
      {/* Неактивное солнце слева (только тёмная тема) */}
      {!isLight && (
        <SunIcon
          className="pointer-events-none absolute left-[12px] top-1/2 z-[1] h-[18px] w-[18px] -translate-y-1/2 text-[#9CA3AC]"
          strokeWidth={1.75}
          aria-hidden
        />
      )}

      {/* Неактивная луна справа (только светлая тема) */}
      {isLight && (
        <MoonIcon
          className="pointer-events-none absolute right-[9px] top-1/2 z-[1] h-[22px] w-[22px] -translate-y-1/2 text-[#64748B]"
          strokeWidth={1.75}
          aria-hidden
        />
      )}

      {/* Бегунок */}
      <span
        className={`pointer-events-none absolute top-1/2 z-[2] flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-black/10 shadow-sm transition-[left,background] duration-300 ease-out ${
          isLight ? 'left-[3px]' : 'left-[42px]'
        }`}
        style={{
          background: isLight
            ? 'linear-gradient(90deg, #4F45E5 0%, #7C3AED 100%)'
            : 'linear-gradient(270deg, #7C3AED -2.78%, #4F45E5 99.35%)',
        }}
      >
        {isLight ? (
          <SunIcon className="h-[22px] w-[22px] text-[#F8F9FA]" strokeWidth={1.75} />
        ) : (
          <MoonIcon className="h-[22px] w-[22px] text-[#E2E8F0]" strokeWidth={1.75} />
        )}
      </span>
    </button>
  );
};

export default ThemeSwitch;
